/**
 * The base Model class. Provides helper functions to make working with models easier.
 */

class Model {
  /**
   * Compares the keys of the values obecjt to properties of the Model, if a match is found
   * assigns the value to the property. Can be used inside a constructor to initialize an object.
   * @param {object} values
   */
  setProps(values) {
    if (!values) {
      return;
    }

    for (let prop in values) {
      if (prop in this) {
        this[prop] = values[prop];
      }
    }
  }
}

export default Model;
